import { Behavior, StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import {
  GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID,
  GLOBAL_KEY_APPROVE_ME_FUNDING_APP,
} from './constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
class SaveApplicationBehavior extends StrictBehavior {
  static readonly DESCRIPTION = 'The behavior to save the application';

  static readonly GLOBAL_OUTPUT_PROPS = {
    error: {
      required: false,
      type: 'Error',
      name: 'error',
      friendlyName: 'Error',
      description: 'An object containing an error',
    },
    fundingApplicationId: {
      required: false,
      name: GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID,
      type: 'number',
      description: 'The returned funding application id',
    },
  };

  static readonly GLOBAL_INPUT_PROPS = {
    fundingApplicationId: {
      required: false,
      name: GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID,
      type: 'number',
      description: 'The current funding application id',
    },
  };

  static readonly VERSION = '1.0.0';

  static readonly ARGS = {
    url: {
      required: false,
      name: 'url',
      type: 'string',
      description: 'The Approve.Me Orchestrator URL',
      default: 'https://vdc-qaswebapp08.stormwind.local/AppMeOrchestrator',
    },
  };

  constructor(public http: HttpClient) {
    super();
  }

  async executeBehavior(args: any, ctx: BehaviorContext): Promise<any> {
    if (!args || !args.url) {
      args = { url: SaveApplicationBehavior.ARGS.url.default };
    }

    const fundingAppId = ctx.get(GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID);
    const formValue = ctx.formGroup.value;

    if (!formValue) {
      ctx.set('error', { message: 'no form value set' });
    }

    // const payload = {
    //   ...formValue
    // };

    // if (fundingAppId || fundingAppId === 0) {
    //   payload.FundingApplicationId = fundingAppId;
    // }
    // TEMPORARY MOCKING

    const payload = {
      FundingApplicationId: 1,
      Mocking: {
        ServicesToMock: ['Approve.Me.Microservice.Orchestrator'],
        FundingApplicationId: 1,

        ResponseStatus_Message: 'Mocked response status message.',
      },
      ...formValue,
    };

    try {
      const result = await this.http
        .post<{ fundingApplicationId: string }>(
          `${args.url}/saveApplication`,
          payload
        )
        .toPromise();
      ctx.set(
        GLOBAL_KEY_APPROVE_ME_FUNDING_APP_ID,
        result.fundingApplicationId
      );

      ctx.merge(GLOBAL_KEY_APPROVE_ME_FUNDING_APP, payload);
    } catch (error) {
      ctx.set('error', error);
    }
  }
}

export { SaveApplicationBehavior };
